import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const createViewStmtInstruction = `
#### Entity View

- Syntax: \`create view <view_name>;\`
- Example: \`create view Products;\`
- Example: \`create view ProductDetail;\`
- Example: \`create view ProductCreate;\`
- Example: \`create view ProductEdit;\`
`;
export const stmtCreateView = ({ viewName }) => {
    return `create view ${viewName};`;
};
export const createViewHandler = createStructureStatementHandler({
    type: 'create view',
    parse: line => {
        const match = /^create view (?<viewName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'create view',
                viewName: match.groups.viewName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.addView(stmt.viewName)),
});
//# sourceMappingURL=CreateViewStmt.js.map